module.exports = __webpack_public_path__ + "img/free-fire.f60e963.jpg";